import React from 'react';
// import shareitlater from './shareitlater.png';
export default function Footer() {
    const handleLinkClick = (event) => {
        event.preventDefault();
        // Add any other logic or actions you want to perform when the link is clicked.
      };
    return (
        <footer  id='footer'>
            <ul className="nav nav-pills nav-fill">
      <h3 className="logo me-auto">
        <a href="/" onClick={handleLinkClick}>
          <img src="assets/img/shareitlater.png" style={{ maxHeight: '55px' }} alt='Home' />
        </a>
      </h3>
      <li className="nav-item">
        <a href="/" className="nav-link text-light" style={{ color: '#FFD700' }} onClick={handleLinkClick}>
          Privacy Policy
        </a>
      </li>
      <li className="nav-item">
        <a href="/" className="nav-link text-light" style={{ color: '#FFD700' }} onClick={handleLinkClick}>
          Safety
        </a>
      </li>
      <li className="nav-item">
        <a href="/" className="nav-link text-light" style={{ color: '#FFD700' }} onClick={handleLinkClick}>
          info@shareitlater.org
        </a>
      </li>
    </ul>
        </footer>
    )
}
